<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)">
                原木
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)">
                湿材
            </div>
        </div>
        <machiningReportDry v-if="tab == 1"></machiningReportDry>
        <machiningReportMet v-if="tab == 2"></machiningReportMet>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;

        .tab_box{
            display: flex; border-bottom: 2px solid #EEEFF2; padding: 9px 28px; margin-bottom: 16px;
            & > div{
                font-size: 16px; color: #222222; font-weight:bold; line-height:23px; position: relative; cursor: pointer;
                & + div { margin-left: 93px; }
            }
            .active::after{ display: block; content: ""; height: 4px; background: #B21111; border-radius:4px; position: absolute; top: 100%; left: -8px; right: -8px;}
        }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                tab : 1
            }
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            }
        },
    }
</script>
